/**
 * CNC Cross-sell Size Sync — Sprint 45B
 * ======================================
 * WHY THIS FILE EXISTS:
 * The Stiletto theme renders the buy-zone upsell (cnc-upsell-section) and
 * cross-sell selects as independent components. When a customer selects a
 * size in the main buy zone, those selects do not automatically update.
 * This file bridges that gap — no theme.js modification required.
 *
 * What it does:
 *   1. Listens for size chip clicks on the PDP (.product__chip)
 *   2. Syncs the selected size to all cross-sell variant selects
 *      ([data-cnc-variant-select] and [data-variant-selector])
 *   3. Updates the sticky ATC bar option text to match the selected variant
 *
 * Also handles:
 *   - Color swatch clicks (sticky bar update)
 *   - Dropdown variant selects (fallback for non-chip products)
 *
 * Does NOT modify theme.js or theme.min.js.
 * Loaded from sections/cnc-upsell-section.liquid (product pages only).
 */

(function () {
  'use strict';

  function getSelectedPdpSize() {
    var chip = document.querySelector('.product__color-chips .product__chip.selected');
    return chip ? chip.textContent.trim() : null;
  }

  function syncCrossSellSelects(size) {
    if (!size) return;

    // Buy-zone upsell selects
    var selects = document.querySelectorAll('[data-cnc-variant-select]');
    selects.forEach(function (sel) {
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].text.trim().split(' ')[0] === size && !sel.options[i].disabled) {
          sel.selectedIndex = i;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }
    });

    // Cart cross-sell selects
    var cartSelects = document.querySelectorAll('[data-variant-selector]');
    cartSelects.forEach(function (sel) {
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].text.trim() === size && !sel.options[i].disabled) {
          sel.selectedIndex = i;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }
    });
  }

  function updateStickyAtcBarOptions() {
    var metaEl = document.querySelector('.sticky-atc-bar__meta-options');
    if (!metaEl) return;

    // Read all selected option values from the buy zone labels
    var optionSpans = document.querySelectorAll('[data-selected-value-for-option]');
    var parts = [];
    optionSpans.forEach(function (span) {
      var val = span.textContent.trim();
      if (val) parts.push(val);
    });

    if (parts.length > 0) {
      metaEl.textContent = parts.join(', ');
    }
  }

  // Listen for PDP chip clicks (size selection)
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('.product__color-chips .product__chip');
    if (!chip) return;
    // Small delay to let the theme mark it as selected
    setTimeout(function () {
      syncCrossSellSelects(getSelectedPdpSize());
      updateStickyAtcBarOptions();
    }, 50);
  });

  // Listen for color swatch clicks too (update sticky bar)
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.product__color-swatches [data-button]');
    if (!swatch) return;
    setTimeout(function () {
      updateStickyAtcBarOptions();
    }, 50);
  });

  // Also sync on variant select change (dropdown fallback)
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[name*="options"]');
    if (!sel || !sel.closest('.product__variants-wrapper')) return;
    var optionLabel = sel.closest('.product__option');
    if (!optionLabel) return;
    var label = optionLabel.querySelector('.product__label');
    if (label && /size/i.test(label.textContent)) {
      syncCrossSellSelects(sel.value);
    }
    updateStickyAtcBarOptions();
  });
})();
